export const naceCodeListMetadata = {
  isComplete: false,
  standard: 'SN2007',
  source: 'LOCAL_FALLBACK',
  warning: 'Fallback-liste. Fullstendige kodeverk hentes fra SSB Klass API når tilgjengelig.'
};

export const geographyCodeListMetadata = {
  isComplete: false,
  source: 'LOCAL_FALLBACK',
  warning: 'Fallback-liste. Fullstendige kommune- og fylkeskodeverk hentes fra SSB Klass API når tilgjengelig.'
};

export const naceCodes = [
  { code: '41.200', label: 'Oppføring av bygninger', standard: 'SN2007', searchableText: '41.200 oppføring av bygninger bygg entreprenør boligbygg næringsbygg', keywords: ['bygg', 'entreprenør', 'boligbygg', 'næringsbygg'], level: 'class', parentCode: '41' },
  { code: '43.320', label: 'Snekkerarbeid', standard: 'SN2007', searchableText: '43.320 snekkerarbeid tømrer snekker innredning', keywords: ['tømrer', 'snekker', 'innredning'], level: 'class', parentCode: '43' },
  { code: '43.210', label: 'Elektrisk installasjonsarbeid', standard: 'SN2007', searchableText: '43.210 elektrisk installasjonsarbeid elektriker elektro', keywords: ['elektriker', 'elektro'], level: 'class', parentCode: '43' },
  { code: '43.220', label: 'VVS-arbeid', standard: 'SN2007', searchableText: '43.220 vvs vvs-arbeid rørlegger rør arbeid', keywords: ['rørlegger', 'vvs'], level: 'class', parentCode: '43' },
  { code: '43.990', label: 'Annen spesialisert bygge- og anleggsvirksomhet', standard: 'SN2007', searchableText: '43.990 annen spesialisert bygge og anleggsvirksomhet bygg anlegg entreprenør', keywords: ['bygg', 'anlegg', 'entreprenør'], level: 'class', parentCode: '43' },
  { code: '81.210', label: 'Rengjøring av bygninger', standard: 'SN2007', searchableText: '81.210 rengjøring av bygninger renhold rengjøring', keywords: ['renhold', 'rengjøring'], level: 'class', parentCode: '81' },
  { code: '56.101', label: 'Drift av restauranter og kafeer', standard: 'SN2007', searchableText: '56.101 drift av restauranter og kafeer restaurant kafe servering', keywords: ['restaurant', 'kafe', 'servering'], level: 'class', parentCode: '56' },
  { code: '69.201', label: 'Regnskap og bokføring', standard: 'SN2007', searchableText: '69.201 regnskap og bokføring regnskap økonomi bokføring', keywords: ['regnskap', 'økonomi', 'bokføring'], level: 'class', parentCode: '69' },
  { code: '70.220', label: 'Bedriftsrådgivning og annen administrativ rådgivning', standard: 'SN2007', searchableText: '70.220 bedriftsrådgivning annen administrativ rådgivning konsulent rådgivning', keywords: ['konsulent', 'rådgivning'], level: 'class', parentCode: '70' },
  { code: '78.100', label: 'Rekruttering og formidling av arbeidskraft', standard: 'SN2007', searchableText: '78.100 rekruttering og formidling av arbeidskraft rekruttering bemanning', keywords: ['rekruttering', 'bemanning'], level: 'class', parentCode: '78' },
  { code: '62.010', label: 'Programmeringstjenester', standard: 'SN2007', searchableText: '62.010 programmeringstjenester it software programvare utvikling', keywords: ['it', 'software', 'programvare', 'utvikling'], level: 'class', parentCode: '62' },
  { code: '49.410', label: 'Godstransport på vei', standard: 'SN2007', searchableText: '49.410 godstransport på vei transport logistikk lastebil', keywords: ['transport', 'logistikk', 'lastebil'], level: 'class', parentCode: '49' }
];

export const naceSuggestions = naceCodes;

export const municipalities = [
  { code: '0301', name: 'Oslo', countyCode: '03', countyName: 'Oslo', searchableText: '0301 oslo' },
  { code: '1103', name: 'Stavanger', countyCode: '11', countyName: 'Rogaland', searchableText: '1103 stavanger rogaland' },
  { code: '1108', name: 'Sandnes', countyCode: '11', countyName: 'Rogaland', searchableText: '1108 sandnes rogaland' },
  { code: '1507', name: 'Ålesund', countyCode: '15', countyName: 'Møre og Romsdal', searchableText: '1507 ålesund møre og romsdal' },
  { code: '1804', name: 'Bodø', countyCode: '18', countyName: 'Nordland', searchableText: '1804 bodø nordland' },
  { code: '3005', name: 'Drammen', countyCode: '30', countyName: 'Viken', searchableText: '3005 drammen viken' },
  { code: '3407', name: 'Gjøvik', countyCode: '34', countyName: 'Innlandet', searchableText: '3407 gjøvik innlandet' },
  { code: '3804', name: 'Sandefjord', countyCode: '38', countyName: 'Vestfold og Telemark', searchableText: '3804 sandefjord vestfold og telemark' },
  { code: '4204', name: 'Kristiansand', countyCode: '42', countyName: 'Agder', searchableText: '4204 kristiansand agder' },
  { code: '4601', name: 'Bergen', countyCode: '46', countyName: 'Vestland', searchableText: '4601 bergen vestland' },
  { code: '5001', name: 'Trondheim', countyCode: '50', countyName: 'Trøndelag', searchableText: '5001 trondheim trøndelag' },
  { code: '5401', name: 'Tromsø', countyCode: '54', countyName: 'Troms og Finnmark', searchableText: '5401 tromsø troms og finnmark' }
];

export const counties = [
  { code: '03', name: 'Oslo', searchableText: '03 oslo' },
  { code: '11', name: 'Rogaland', searchableText: '11 rogaland' },
  { code: '15', name: 'Møre og Romsdal', searchableText: '15 møre og romsdal' },
  { code: '18', name: 'Nordland', searchableText: '18 nordland' },
  { code: '30', name: 'Viken', searchableText: '30 viken' },
  { code: '34', name: 'Innlandet', searchableText: '34 innlandet' },
  { code: '38', name: 'Vestfold og Telemark', searchableText: '38 vestfold og telemark' },
  { code: '42', name: 'Agder', searchableText: '42 agder' },
  { code: '46', name: 'Vestland', searchableText: '46 vestland' },
  { code: '50', name: 'Trøndelag', searchableText: '50 trøndelag' },
  { code: '54', name: 'Troms og Finnmark', searchableText: '54 tromsø og finnmark' }
];

export const organizationForms = [
  { code: 'AS', label: 'Aksjeselskap', display: 'Aksjeselskap (AS)' },
  { code: 'ENK', label: 'Enkeltpersonforetak', display: 'Enkeltpersonforetak (ENK)' },
  { code: 'DA', label: 'Delt Ansvar', display: 'Delt Ansvar (DA)' },
  { code: 'ANS', label: 'Ansvarlig Selskap', display: 'Ansvarlig Selskap (ANS)' },
  { code: 'NUF', label: 'Norskregistrert utenlandsk foretak', display: 'Norskregistrert utenlandsk foretak (NUF)' }
];

export const normalizeNaceCode = (value) => {
  const normalized = String(value || '').trim().replace(/\s/g, '');

  if (/^\d{5}$/.test(normalized)) {
    return `${normalized.slice(0, 2)}.${normalized.slice(2)}`;
  }

  return normalized;
};

export const searchNaceCodes = (value) => {
  const query = String(value || '').trim().toLowerCase();
  const normalizedQuery = normalizeNaceCode(query).toLowerCase();

  if (!query) return [];

  return naceCodes.filter((item) => {
    const searchableText = item.searchableText.toLowerCase();
    const compactQuery = query.replace('.', '');

    return item.code.toLowerCase().includes(normalizedQuery)
      || item.code.replace('.', '').includes(compactQuery)
      || searchableText.includes(query)
      || searchableText.includes(normalizedQuery);
  });
};